import React from 'react';

import {
  Container,
  FlexContainer,
  ImageProfile,
  ListContainer,
  WrapQuotes,
  RatingRow,
  StarsWrapper,
  Star,
  RatingCount,
} from './styles';

import {
  Line,
  TextCustom,
} from '../styles';

import starGrey from '../../../../assets/img/star-grey.png';
import starOrange from '../../../../assets/img/star.png';

import starOrangeGrey from '../../../../assets/img/star-half.png';

const getStar = (rating, indexRating, starFull, starHalf, starEmpty) => {
  const ratingRound = Math.floor(rating);
  if (indexRating <= ratingRound) {
    return starFull;
  }
  if (indexRating > ratingRound + 1) {
    return starEmpty;
  }
  if (rating - ratingRound < 0.25) {
    return starEmpty;
  }
  if (rating - ratingRound >= 0.75 && ratingRound < 4) {
    return starFull;
  }
  return starHalf;
};

const SectionQuotes = ({ quotes }) => {
  const RatingPDF = ({ rating, ratings_total }) => {
    const arrRating = [];
    for (let index = 1; index <= 5; index += 1) {
      arrRating.push(getStar(rating, index, starOrange, starOrangeGrey, starGrey));
    }

    return (
      <RatingRow>
        <StarsWrapper>
          {arrRating.map((s, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <Star key={`star-${index}`} src={s} />
          ))}
          <RatingCount>{`(${ratings_total})`}</RatingCount>
        </StarsWrapper>
      </RatingRow>
    );
  };

  const QuotesCard = ({ quote }) => (
    <Container>
      <FlexContainer row flex="2" margin="0 0 10px 0">
        <FlexContainer vAlign="center" flex="2">
          <ImageProfile
            crossorigin="anonymous"
            src={
            process.env.NODE_ENV === 'production'
              ? `${quote.profile_picture}?noCache=${Math.random().toString()}`
              : `${quote.profile_picture.replace(/^https:\/\//i, 'http://')}?noCache=${Math.random().toString()}`
          }
          />
        </FlexContainer>
        <FlexContainer vAlign="start" flex="3">
          <TextCustom bold size="13px">{quote.user_name}</TextCustom>
          <RatingRow>
            <RatingPDF rating={quote.rating} ratings_total={quote.ratings_total} />
          </RatingRow>
          <TextCustom size="8px" color="#A1A1A1">
            {`${quote.pro_deals} negócios fechados`}
          </TextCustom>
          <TextCustom bold size="10px" margin="5px 0 0 0">Descrição:</TextCustom>
          <TextCustom size="8px">
            {quote.task_description && quote.task_description.length > 110
              ? `${quote.task_description.substring(0, 107)}...`
              : quote.task_description || 'Nenhuma descrição do serviço'
              }
          </TextCustom>
        </FlexContainer>
      </FlexContainer>

      <Line />

      <FlexContainer row flex="1" margin="5px 0 0 0">
        <FlexContainer vAlign="center" flex="3">
          <TextCustom size="11px">
            Serviço:
            <TextCustom size="11px" bold color="#F07E31">
              {quote.material_price
                ? ` R$${quote.material_price}`
                : ' R$0,00'
              }
            </TextCustom>
          </TextCustom>
          <TextCustom size="11px">
            {'Mão de obra: '}
            <TextCustom size="11px" bold color="#F07E31">
              {quote.task_price
                ? ` R$${quote.task_price}`
                : ' R$0,00'
              }
            </TextCustom>
          </TextCustom>
        </FlexContainer>
        <Line vertical margin="0 5px 0 5px" />
        <FlexContainer vAlign="center" flex="2">
          <TextCustom size="12px" bold>
            {'Total: '}
            <TextCustom size="12px" bold color="#F07E31">
              {`R$${quote.price}`}
            </TextCustom>
          </TextCustom>
        </FlexContainer>
      </FlexContainer>
    </Container>
  );
  return (
    <ListContainer>
      <TextCustom size="14px" bold color="#F07E31" margin="15px 0 0 0">Orçamentos recebidos:</TextCustom>
      <WrapQuotes>
        {quotes.map(quote => (<QuotesCard key={quote.id} quote={quote} />))}
      </WrapQuotes>
    </ListContainer>
  );
};


export default SectionQuotes;
